'use client';

import { Copy } from 'iconsax-react';

import { cn } from '@shared/lib';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../tooltip';
import { language, useCopyButton } from '../model';
import { TCopyButtonProps } from '../model/types';

export const CopyButton = ({
  text,
  duration = 1500,
  className,
  children,
  onCopied,
  tooltipLabel = language.tooltipLabel,
  successLabel = language.successLabel,
}: TCopyButtonProps) => {
  const { state, handlers } = useCopyButton({ text, duration, onCopied });
  const { copied, open } = state;

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip open={open} onOpenChange={handlers.handleOpenChange}>
        <TooltipTrigger asChild>
          <button
            type='button'
            onClick={handlers.handleCopy}
            onMouseEnter={() => handlers.setOpen(true)}
            onMouseLeave={() => handlers.setOpen(false)}
            className={cn('group relative inline-flex items-center justify-center', className)}
          >
            {children ? children : <Copy size={24} className='transition-all duration-200' />}
          </button>
        </TooltipTrigger>
        <TooltipContent key={copied ? 'copied' : 'default'}>
          <p className='body-11-regular'>{copied ? successLabel : tooltipLabel}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
